

































































import { useFloorplanStore } from "@/pinia/floorplan-store";
import SidebarReservation from "@/views/floorplan/sidebar-reservation.vue";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
    name: "sidebarReservations",
    components: { SidebarReservation },
    props: {},
    setup(props, ctx) {
        const floorplanStore = useFloorplanStore();

        return { floorplanStore };
    },
});
